import { useRef } from "react";

/**
 * Bot-protection helper shared by every lead form.
 *
 * Renders a hidden decoy input real visitors never see or tab into, and tracks
 * when the form mounted so instant (scripted) submissions can be flagged on the
 * server. The field name is deliberately meaningless ("ref_code_x") so browser
 * address autofill and password managers do not fill it for real people — a
 * recognisable name like "company_website" gets autofilled and silently killed
 * real leads.
 */
export function useLeadGuard() {
  const hpRef = useRef<HTMLInputElement>(null);
  const mountedAtRef = useRef<number>(Date.now());

  function guardFields() {
    return {
      hp: hpRef.current?.value ?? "",
      t: mountedAtRef.current,
    };
  }

  const honeypot = (
    <div aria-hidden="true" className="absolute left-[-9999px] h-0 w-0 overflow-hidden">
      <input
        ref={hpRef}
        type="text"
        name="ref_code_x"
        tabIndex={-1}
        autoComplete="off"
        data-lpignore="true"
        data-1p-ignore="true"
        data-form-type="other"
        defaultValue=""
      />
    </div>
  );

  return { honeypot, guardFields };
}

